module.exports = __webpack_public_path__ + "media/images/emblems/Gretzenbach-blason-c4cddf65c3549bc45b68b16e397318ed.png";